<!-- Contentblok afbeelding links, witte achtergrond -->
<article class="content-block-default" [class.has--text-only]="!block.image.url">
  <div class="container" [class.container-size-sm]="!block.image.url">
    <div class="row align-items-center section-outset-y">
      <figure class="col-lg-6 content-block-default__figure mt-4 mt-md-0" *ngIf="block.image.url">
        <img [src]="block.image.url | resize: 800:undefined:block.image.anchor" [alt]="block.title" />
      </figure>
      <main class="col-lg-6 content-block-default__main">
        <h1 class="h2 pb-4 content-block-default__title">{{ block.title }}</h1>
        <p class="text-muted type-body-sm" [innerHTML]="block?.text"></p>

        <footer class="mt-4" *ngIf="block?.button?.routerLink || block?.button?.url">
          <a class="button button--primary" [routerLink]="block.button.routerLink" *ngIf="block.button.routerLink">
            <span>{{ block?.button?.text || ('lees-meer' | fromDictionary) }}</span>
            <app-icon class="icon-chevron-right" anchor="icon-chevron-right"></app-icon>
          </a>
          <a class="button button--primary" [href]="block.button.url" *ngIf="!block.button.routerLink">
            <span>{{ block?.button?.text || ('lees-meer' | fromDictionary) }}</span>
            <app-icon class="icon-chevron-right" anchor="icon-chevron-right"></app-icon>
          </a>
        </footer>
      </main>
    </div>
  </div>
</article>
